import supabase from './supabase';

export async function getCityOptions() {
  const { data, error } = await supabase
    .from('locations')
    .select('city, city_sort_order')
    .order('city_sort_order', { ascending: true });

  if (error) {
    console.error('Error fetching city options:', error);
    return [];
  }

  const seen = new Set();
  const cities = [];
  for (const row of data ?? []) {
    if (!seen.has(row.city)) {
      seen.add(row.city);
      cities.push({ key: row.city, label: row.city });
    }
  }
  return cities;
}

export async function getNeighborhoodOptions(city) {
  if (!city) return [];

  const { data, error } = await supabase
    .from('locations')
    .select('neighborhood')
    .eq('city', city)
    .order('neighborhood_sort_order', { ascending: true });

  if (error) {
    console.error(`Error fetching neighborhoods for city "${city}":`, error);
    return [];
  }

  return (data ?? []).map(row => ({ key: row.neighborhood, label: row.neighborhood }));
}